import React from 'react'
import { Modal } from 'components/utility/react-modal'
import { getPackageModalHost } from 'lib/openPackageModal'

export default function PackageModal({ children, ...props }) {
  return (
    <Modal container={getPackageModalHost()} {...props}>
      {children}
    </Modal>
  )
}
